import {createJSONStorage, type StateStorage} from "zustand/middleware";

import {getStorageItem, setStorageItem} from "./storage";

const noopStorage: StateStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

function isBrowserStorageAvailable(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const probeKey = "__zustand_storage_probe__";
    window.localStorage.setItem(probeKey, "1");
    window.localStorage.removeItem(probeKey);
    return true;
  } catch {
    return false;
  }
}

/** Backing storage for zustand persist — must return JSON strings from getItem. */
export const customStorage: StateStorage = {
  getItem: (name: string) => {
    try {
      const value = getStorageItem(name, false);
      if (value == null) return null;
      return typeof value === "string" ? value : JSON.stringify(value);
    } catch (error) {
      console.error("Error getting storage item:", error);
      return null;
    }
  },
  setItem: (name: string, value: string) => {
    try {
      setStorageItem(name, value);
    } catch (error) {
      console.error("Error setting storage item:", error);
    }
  },
  removeItem: (name: string) => {
    try {
      setStorageItem(name, null);
    } catch (error) {
      console.error("Error removing storage item:", error);
    }
  },
};

function resolvePersistBackingStorage(): StateStorage {
  return isBrowserStorageAvailable() ? customStorage : noopStorage;
}

/** Shared persist storage — never undefined (avoids zustand "storage unavailable" warnings). */
export const zustandPersistStorage = createJSONStorage(resolvePersistBackingStorage);
